//if not contain alot of code can be in getBasicSettingsData

//images size limits
export const jumbomailImagesSizeLimit = {
  signatureHeader: 10485760,
  signatureLogo: 31457280,
  businessLogo: 31457280,
  profilePicture: 31457280,
  coverBackground: 10485760,
  embedPageBackground: 10485760,
  embedPageLogo: 31457280,
  FormImage: 31457280,
};

//languages, directions and currencies

//dropdown languages list
export const dropdownLanguage = [
  "English - LTR",
  "עברית - RTL",
  "русский - LTR",
  "italiano - LTR",
  "español - LTR",
  "عربى - RTL",
];

//DropDownlist without directions
export const languagesList = [
  "English",
  "עברית",
  "Pусский",
  "Italiano",
  "Español",
  "عربى",
];

//language short list
export const languageShortList = ["en", "he", "ru", "it", "es", "ar"];
export const languageShortListFullName = [
  "en-US",
  "he-IL",
  "ru-RU",
  "it-IT",
  "es-ES",
  "ar-SA",
];

//language full list
export const languageListObjects = [
  { code: "en", title: "English - LTR" },
  { code: "he", title: "עברית - RTL" },
  { code: "ru", title: "Pусский - LTR" },
  { code: "it", title: "Italiano - LTR" },
  { code: "es", title: "Español - LTR" },
  { code: "ar", title: "عربى - RTL" },
];

export const currencies = {
  nis: "₪",
  eur: "€",
  usd: "$",
};

export const eurList = [
  "Andorra",
  "Albania",
  "Austria",
  "Åland Islands",
  "Bosnia and Herzegovina",
  "Belgium",
  "Bulgaria",
  "Belarus",
  "Switzerland",
  "Cyprus",
  "Czech Republic",
  "Germany",
  "Denmark",
  "Estonia",
  "Spain",
  "Finland",
  "Faroe Islands",
  "France",
  "United Kingdon",
  "Guernsey",
  "Greece",
  "Croatia",
  "Hungary",
  "Ireland",
  "Isle of Man",
  "Iceland",
  "Italy",
  "Jersey",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Latvia",
  "Monaco",
  "Moldova, Republic of",
  "Macedonia, The Former Yugoslav Republic of",
  "Malta",
  "Netherlands",
  "Norway",
  "Poland",
  "Portugal",
  "Romania",
  "Russian Federation",
  "Sweden",
  "Slovenia",
  "Svalbard and Jan Mayen",
  "Slovakia",
  "San Marino",
  "Ukraine",
  "Holy See (Vatican City State)",
];
export const nisList = ["Israel"];

//Packages
export const planSystemNameList = ["pro", "business", "premium"];

export const plansTitleList = {
  free: "JM Free",
  pro: "JM Pro",
  business: "JM Business",
  premium: "JM Premium",
};

export const plansStorages = {
  free: 0,
  pro: 536870912000,
  business: 1099511627776,
  premium: 1099511627776,
};

export const TBinBytes = 1099511627776;
